import api from 'utils/api';

const LOAD_ITEMS = 'projects/LOAD_ITEMS';

const initialState = {
    items: {},
    itemIds: [],
    limit: 6,
    hasMore: true,
    startLoad: true,
};

export default function projectsReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_ITEMS: {
            const normalizedItems = {};
            const itemIds = action.clear ? [] : [...state.itemIds];

            action.items.forEach((item) => {
                normalizedItems[item.id] = item;

                if (!itemIds.includes(item.id)) {
                    itemIds.push(item.id);
                }
            });

            const items = action.clear ? normalizedItems : { ...state.items, ...normalizedItems };

            return {
                ...state,
                hasMore: action.count > itemIds.length,
                items,
                itemIds,
                startLoad: false,
            };
        }

        default: {
            return state;
        }
    }
}

const setItems = (items, count, clear) => ({ type: LOAD_ITEMS, items, count, clear });

export const loadItems = (clear = false) => (dispatch, getState) => {
    const state = getState();
    const { itemIds, limit } = state;

    const queryParams = {
        offset: clear ? 0 : itemIds.length,
        limit,
    };

    api.projects.fetch(null, queryParams).then((result) => {
        dispatch(setItems(result.results, result.count, clear));
    });
};



// WEBPACK FOOTER //
// ./src/ducks/projectlist.js